module.exports = __webpack_public_path__ + "img/part9-4.2d5ef282.png";